var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Town Objects')))]), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l(_vm.$store.state.$db.TownObjectListArray, function (item) {
    return _c('v-col', {
      key: "town-objects-item-".concat(item.m_ID),
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-divider'), _c('TownObject', {
      attrs: {
        "id": item.m_ID
      }
    })], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }